import { useQuery } from '@tanstack/react-query';
import { cms } from 'admin/resources';
import { cmsKeys } from 'admin/queries/queryKeys';
import type { EmbeddingConfiguration } from 'types/cms';

interface GetEmbeddingConfigurationInput {
	collectionId: string;
}

export const getEmbeddingConfigurationQueryFn = async ({
	collectionId,
}: GetEmbeddingConfigurationInput): Promise<EmbeddingConfiguration | null> => {
	const response = await cms.get.embeddingConfiguration
		.params({ collectionId })
		.send<ApiV2Response<EmbeddingConfiguration>>();
	return response.body ?? null;
};

export const useEmbeddingConfiguration = ({ collectionId }: GetEmbeddingConfigurationInput) => {
	return useQuery({
		queryKey: cmsKeys.embeddingConfiguration(collectionId),
		queryFn: () => getEmbeddingConfigurationQueryFn({ collectionId }),
		enabled: Boolean(collectionId),
	});
};
